import { render } from "./Details.vue?vue&type=template&id=68b2b84f&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=68b2b84f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68b2b84f"

export default script